import React, { Component } from 'react';
import { Route, Redirect } from 'react-router'

export default class HomeView extends Component {
	render() {

		return this.props.auth 
					? <Redirect to={"/flm"} /> 
					: <Redirect to={"/login"} />
			 
			
	}
}

